import { render, staticRenderFns } from "./SfInput.vue?vue&type=template&id=546d05fc&scoped=true"
import script from "./SfInput.vue?vue&type=script&lang=js"
export * from "./SfInput.vue?vue&type=script&lang=js"
import style0 from "./SfInput.vue?vue&type=style&index=0&id=546d05fc&prod&scoped=true&lang=css"
import style1 from "./SfInput.vue?vue&type=style&index=1&id=546d05fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546d05fc",
  null
  
)

export default component.exports